import './App.css';
import Routers from './components/layouts/Routers';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './styles/global-styles';
import { theme } from './styles/theme';

declare global {
  interface Window {
    kakao: any;
  }
}

function App() {
  const dispatch = useDispatch();

  // @ts-ignore
  if (window.Cypress) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      const auth0 = JSON.parse(localStorage.getItem('auth0Cypress')!);
      console.log(auth0.token);
      localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME!, auth0.token);
    }, [dispatch]);
  }

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <>
        <Helmet>
          <title>하이공사</title>
        </Helmet>
        <Routers />
      </>
    </ThemeProvider>
  );
}

export default App;
